import { BRIDGE_SITE_PATH_LIST } from "./bridgeSitePaths";
import isExternalHref from "./isExternalHref";

type Input = { href: string; isBridgeSite: boolean; domain: string };

type Parsed = { isExternal: boolean; href: string };

// Bridge classification for already-localised hrefs. A builder's output is
// never rewritten — legacy path translation (replaceMappedPath) stays in the
// automatic mode — so the only question is which side of the bridge owns the
// path, answered against the list without the locale prefix.
const getParsedHrefLocalized = ({
  href,
  isBridgeSite,
  domain,
}: Input): Parsed => {
  if (isExternalHref(href)) {
    return { isExternal: true, href };
  }
  if (!isBridgeSite || !isBridgePath(href)) {
    return { isExternal: false, href };
  }
  return { isExternal: true, href: `https://${domain}${href}` };
};

const isBridgePath = (href: string): boolean => {
  const path = unlocalized(href);
  return BRIDGE_SITE_PATH_LIST.some((entry) => path.startsWith(entry));
};

// The package's locale heuristic (any two-letter first segment), matching
// removeLanguageFromUrl until callers supply real locale lists. "/id" always
// reads as Indonesian here: builders never emit the legacy "/id" auth
// section, which is automatic-mode vocabulary (SBFE-1833).
const unlocalized = (href: string): string => {
  const [, first = "", ...parts] = href.split("/");
  if (first.length === 2) {
    return `/${parts.join("/")}`;
  }
  return href;
};

export default getParsedHrefLocalized;
